import smartlookClient from 'smartlook-client'

smartlookClient.init('7ac87885e7ec709f222589c95c8d25252c3e4bc7')

export default smartlookClient